import { ActivityLogEvent } from "@/gql/graphql";

/**
 * The milestones of a work order, as opposed to everything its activity log
 * holds - the attribute churn of ordinary saves would bury a conversation.
 * The Activity tab remains the full record.
 */
export const threadTimelineEvents = [
  ActivityLogEvent.WorkOrderQuoteRequested,
  ActivityLogEvent.WorkOrderQuoteIssued,
  ActivityLogEvent.WorkOrderQuoteAccepted,
  ActivityLogEvent.WorkOrderQuoteRejected,
  ActivityLogEvent.WorkOrderDriverAssigned,
  ActivityLogEvent.WorkOrderDriverUnassigned,
  ActivityLogEvent.WorkOrderAssigningDrivers,
  ActivityLogEvent.WorkOrderDriversAssigned,
  ActivityLogEvent.WorkOrderInProgress,
  ActivityLogEvent.WorkOrderInvoiced,
  ActivityLogEvent.WorkOrderCompleted,
  ActivityLogEvent.WorkOrderArchived,
  ActivityLogEvent.AssignmentOnRoad,
  ActivityLogEvent.AssignmentDelivered,
  ActivityLogEvent.AssignmentCompleted,
  ActivityLogEvent.AssignmentPayoutCreated,
  ActivityLogEvent.AssignmentPayoutDeleted,
  ActivityLogEvent.AssignmentDriverRated,
];
